import { GENERAL__ERROR_MESSAGE, KIOSK__OFFLINE_MESSAGE } from 'translations/constants';

/**
 * Returns the translation key to display for a kiosk error.
 *
 * Backend kiosk errors come back as `{ error: "<key>" }`, where `<key>` is already a
 * backend-managed translation key (e.g. "[KIOSK] NOT_AUTHORIZED"). Because the web app's i18n is
 * backend-driven, that key resolves through `t()` directly — there is no need to mirror the keys
 * on the client. We only supply our own message when there is no usable backend text.
 */
export const mapKioskError = (error: unknown): string => {
  const axiosError = error as { response?: { data?: { error?: string } } };

  // No response at all => couldn't reach the backend (offline / timeout).
  if (!axiosError?.response) {
    return KIOSK__OFFLINE_MESSAGE;
  }

  return axiosError.response?.data?.error || GENERAL__ERROR_MESSAGE;
};
